import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  opacity: number;
  rotationY: number;
  isHomePage: boolean;
}

const Logo: React.FC<LogoProps> = ({ opacity, rotationY, isHomePage }) => {
  return (
    <Link to="/" className="flex items-center relative z-50" style={{ perspective: '1000px' }}>
      <img 
        src="/EDENXFINALLOGO.svg" 
        alt="EDNX Logo" 
        className="h-16 w-16 md:h-20 md:w-20 transition-all duration-300"
        style={{ 
          opacity,
          transform: isHomePage && window.innerWidth > 768 ? `rotateY(${rotationY}deg)` : 'none',
          transformStyle: 'preserve-3d',
          backfaceVisibility: 'visible'
        }}
      />
    </Link>
  );
};

export default Logo;